// @flow

import React from "react";
import { localize } from "redux-i18n";
import { View, Text, SchemaTable } from "@components";
import type { HierarchyAssignment } from "@modules/service/types";
import schema from "./schema";
import { uiSchema } from "./ui-schema";

type OwnProps = $Exact<{
  assignments: Array<HierarchyAssignment>,
  editing: boolean,
  onChange?: (assignments: Array<Object>) => void,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

export class HierarchyScopeExcludedAreas extends React.Component<Props> {
  get exclusions() {
    return this.props.assignments.reduce((acc: *, a) => {
      if (a.exclusions && a.exclusions.length) {
        return [
          ...acc,
          ...a.exclusions.map(i => {
            return {
              activeFrom: i.activeFrom,
              activeTo: i.activeTo,
              target: i.target.label,
              id: i.target.id,
            };
          }),
        ];
      }
      return acc;
    }, []);
  }

  handleChange = (exclusions: Array<Object>) => {
    if (this.props && this.props.onChange) {
      this.props.onChange(exclusions);
    }
  };

  render() {
    return (
      <View>
        <Text type="h6" text={this.props.t("HIERARCHY_SCOPE_AREAS_EXCLUDED")} />
        {!!this.exclusions.length && (
          <SchemaTable
            tableData={this.exclusions}
            schema={schema}
            uiSchema={uiSchema(this.props.t)}
            onChange={this.handleChange}
            disabled={!this.props.editing}
            allowDeletes
          />
        )}
      </View>
    );
  }
}

export default localize()(HierarchyScopeExcludedAreas);
